import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0C1B26] text-white pt-12 pb-6" data-id="element-658">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-659">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-660">
          {/* Company Info */}
          <div data-id="element-661">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6QmLb9SHG8EWoZXcAsBKy5/Header_Bright_Pixxel_Logo_.png" alt="Bright Pixxel Studios" className="h-14 mb-4" data-id="element-662" />
            <p className="text-white/70 text-sm mb-4" data-id="element-663">
              UK-based web design, e-commerce, and SEO services. Creating
              beautiful, high-performing websites that drive results.
            </p>
            <a href="mailto:info@bright-pixxel.com" className="flex items-center text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-664">
              <MailIcon size={16} className="mr-2" data-id="element-665" />
              info@bright-pixxel.com
            </a>
          </div>
          {/* Services */}
          <div data-id="element-666">
            <h3 className="text-lg font-bold mb-4" data-id="element-667">Services</h3>
            <ul className="space-y-2" data-id="element-668">
              <li data-id="element-669">
                <Link to="/services/web-design" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-670">
                  Web Design
                </Link>
              </li>
              <li data-id="element-671">
                <Link to="/services/ecommerce" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-672">
                  E-Commerce
                </Link>
              </li>
              <li data-id="element-673">
                <Link to="/services/branding" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-674">
                  Branding
                </Link>
              </li>
              <li data-id="element-675">
                <Link to="/services/seo" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-676">
                  SEO Services
                </Link>
              </li>
              <li data-id="element-677">
                <Link to="/services/maintenance" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-678">
                  Website Maintenance
                </Link>
              </li>
            </ul>
          </div>
          {/* Company */}
          <div data-id="element-679">
            <h3 className="text-lg font-bold mb-4" data-id="element-680">Company</h3>
            <ul className="space-y-2" data-id="element-681">
              <li data-id="element-682">
                <Link to="/about" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-683">
                  About Us
                </Link>
              </li>
              <li data-id="element-684">
                <Link to="/portfolio" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-685">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-686">
                <Link to="/pricing" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-687">
                  Pricing
                </Link>
              </li>
              <li data-id="element-688">
                <Link to="/faq" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-689">
                  FAQ
                </Link>
              </li>
              <li data-id="element-690">
                <Link to="/contact" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-691">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div data-id="element-692">
            <h3 className="text-lg font-bold mb-4" data-id="element-693">Legal</h3>
            <ul className="space-y-2" data-id="element-694">
              <li data-id="element-695">
                <Link to="/privacy" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-696">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-697">
                <Link to="/terms" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-698">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-699">
                <Link to="/cancellation" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-700">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-701">
                <Link to="/policies" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-702">
                  All Policies
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/10" data-id="element-703">
          <p className="text-white/70 text-sm text-center" data-id="element-704">
            © {currentYear} Bright Pixxel Studios. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}